/* ============================================================
   SIR UNKNOWN APPAREL — THEME.JS
   Cart Drawer · Quick Add · Variant Picker · All UI
   ============================================================ */
(function () {
  'use strict';

  /* ---- HELPERS ---- */
  const $ = id => document.getElementById(id);
  const $$ = sel => document.querySelectorAll(sel);
  const money = cents => '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  /* ---- ANNOUNCEMENT + NAV HEIGHT ---- */
  function setNavOffset() {
    const ann = document.querySelector('.announcement-bar');
    const h = ann ? ann.offsetHeight : 0;
    document.documentElement.style.setProperty('--ann-h', h + 'px');
  }
  setNavOffset();

  /* ---- STICKY HEADER ---- */
  const header = document.getElementById('site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('scrolled', window.scrollY > 40);
    }, { passive: true });
  }

  /* ---- MOBILE NAV ---- */
  const burger = $('header-burger');
  const mobileNav = $('mobile-nav');
  if (burger && mobileNav) {
    burger.addEventListener('click', () => {
      const open = mobileNav.classList.toggle('open');
      burger.classList.toggle('open', open);
      burger.setAttribute('aria-expanded', open);
      mobileNav.setAttribute('aria-hidden', !open);
      document.body.style.overflow = open ? 'hidden' : '';
    });
    mobileNav.querySelectorAll('a').forEach(a => {
      a.addEventListener('click', () => {
        mobileNav.classList.remove('open');
        burger.classList.remove('open');
        burger.setAttribute('aria-expanded', false);
        document.body.style.overflow = '';
      });
    });
  }

  /* ---- SEARCH BAR ---- */
  const searchBtn = $('header-search-btn');
  const searchBar = $('header-search');
  if (searchBtn && searchBar) {
    searchBtn.addEventListener('click', () => {
      const open = searchBar.classList.toggle('open');
      searchBar.setAttribute('aria-hidden', !open);
      if (open) searchBar.querySelector('input').focus();
    });
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape') searchBar.classList.remove('open');
    });
  }

  /* ---- TOAST ---- */
  function showToast(msg, duration = 3000) {
    const toast = $('toast');
    if (!toast) return;
    toast.textContent = msg;
    toast.classList.add('show');
    clearTimeout(toast._timer);
    toast._timer = setTimeout(() => toast.classList.remove('show'), duration);
  }

  /* ============================================================
     CART DRAWER
  ============================================================ */
  const cartDrawer = $('cart-drawer');
  const cartOverlay = $('cart-overlay');
  const cartClose = $('cart-close');
  const cartBody = $('cart-drawer-body');
  const cartFooter = $('cart-drawer-footer');
  const cartCountEl = $('header-cart-count');

  function openCart() {
    cartDrawer?.classList.add('open');
    cartOverlay?.classList.add('open');
    cartDrawer?.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    renderCart();
  }

  function closeCart() {
    cartDrawer?.classList.remove('open');
    cartOverlay?.classList.remove('open');
    cartDrawer?.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  $('header-cart-btn')?.addEventListener('click', openCart);
  cartClose?.addEventListener('click', closeCart);
  cartOverlay?.addEventListener('click', closeCart);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeCart(); });

  async function getCart() {
    const res = await fetch('/cart.js');
    return res.json();
  }

  function updateCartCount(count) {
    if (cartCountEl) {
      cartCountEl.textContent = count > 0 ? count : '';
      cartCountEl.style.display = count > 0 ? 'flex' : 'none';
    }
  }

  async function renderCart() {
    if (!cartBody) return;
    cartBody.innerHTML = '<div class="cart-drawer__loading">Loading...</div>';
    const cart = await getCart();
    updateCartCount(cart.item_count);

    if (cart.item_count === 0) {
      cartBody.innerHTML = `
        <div class="cart-drawer__empty">
          <p>Your cart is empty.</p>
          <a class="btn btn--outline btn--sm" href="/collections/all">Browse Collection</a>
        </div>`;
      if (cartFooter) cartFooter.innerHTML = '';
      return;
    }

    cartBody.innerHTML = cart.items.map((item, i) => `
      <div class="drawer-item" data-line="${i + 1}">
        <div class="drawer-item__img">
          ${item.image ? `<img src="${item.image.replace('.jpg', '_200x200.jpg')}" alt="${item.product_title}" loading="lazy">` : ''}
        </div>
        <div class="drawer-item__info">
          <a href="${item.url}" class="drawer-item__title">${item.product_title}</a>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<p class="drawer-item__variant">${item.variant_title}</p>` : ''}
          <p class="drawer-item__price">${money(item.final_line_price)}</p>
          <div class="drawer-item__qty">
            <button class="drawer-qty-btn" data-line="${i + 1}" data-action="decrease" aria-label="Decrease">−</button>
            <span class="drawer-item__qty-val">${item.quantity}</span>
            <button class="drawer-qty-btn" data-line="${i + 1}" data-action="increase" aria-label="Increase">+</button>
          </div>
          <button class="drawer-item__remove" data-line="${i + 1}">Remove</button>
        </div>
      </div>
    `).join('');

    if (cartFooter) {
      cartFooter.innerHTML = `
        <div class="cart-drawer__subtotal">
          <span>Subtotal</span>
          <span>${money(cart.total_price)}</span>
        </div>
        <a href="/checkout" class="btn btn--gold btn--full cart-drawer__checkout">Checkout Securely →</a>
        <p class="cart-drawer__trust">🔒 Secure SSL · Free Shipping $75+</p>
      `;
    }

    // Qty buttons
    cartBody.querySelectorAll('.drawer-qty-btn').forEach(btn => {
      btn.addEventListener('click', async () => {
        const line = parseInt(btn.dataset.line);
        const item = cart.items[line - 1];
        const qty = btn.dataset.action === 'increase' ? item.quantity + 1 : item.quantity - 1;
        await updateCartLine(line, Math.max(0, qty));
        renderCart();
      });
    });

    // Remove buttons
    cartBody.querySelectorAll('.drawer-item__remove').forEach(btn => {
      btn.addEventListener('click', async () => {
        await updateCartLine(parseInt(btn.dataset.line), 0);
        renderCart();
      });
    });
  }

  async function updateCartLine(line, quantity) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line, quantity })
    });
    const cart = await res.json();
    updateCartCount(cart.item_count);
    return cart;
  }

  async function addToCart(variantId, quantity = 1) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity }] })
    });
    if (!res.ok) throw new Error('Could not add to cart');
    const cart = await getCart();
    updateCartCount(cart.item_count);
    return cart;
  }

  /* ============================================================
     PRODUCT PAGE
  ============================================================ */
  const productForm = document.getElementById('product-form');
  if (productForm && window.__productVariants) {
    const variants = window.__productVariants;
    const variantInput = $('variant-id');
    const addToCartBtn = $('add-to-cart');
    const priceEl = $('product-price');
    const comparePriceEl = $('product-compare-price');
    const stockEl = $('product-stock');

    let selectedOptions = {};

    // Init selected options from checked inputs
    $$('.product-option').forEach(group => {
      const idx = parseInt(group.dataset.optionIndex);
      const checked = group.querySelector('input[type=radio]:checked');
      if (checked) selectedOptions[idx] = checked.value;
    });

    function findVariant() {
      return variants.find(v =>
        Object.entries(selectedOptions).every(([idx, val]) => v[`option${parseInt(idx) + 1}`] === val)
      ) || variants[0];
    }

    function updateUI(variant) {
      if (!variant) return;
      if (variantInput) variantInput.value = variant.id;

      // Price
      if (priceEl) priceEl.textContent = money(variant.price);
      if (comparePriceEl) {
        if (variant.compare_at_price > variant.price) {
          comparePriceEl.textContent = money(variant.compare_at_price);
          comparePriceEl.style.display = '';
        } else {
          comparePriceEl.style.display = 'none';
        }
      }

      // Stock
      if (stockEl) {
        if (!variant.available) {
          stockEl.innerHTML = '<span class="stock-out">Sold Out</span>';
        } else if (variant.inventory_quantity > 0 && variant.inventory_quantity <= 5) {
          stockEl.innerHTML = `<span class="stock-low">⚡ Only ${variant.inventory_quantity} left!</span>`;
        } else {
          stockEl.innerHTML = '<span class="stock-in">✓ In Stock</span>';
        }
      }

      // ATC button
      if (addToCartBtn) {
        addToCartBtn.disabled = !variant.available;
        addToCartBtn.textContent = variant.available
          ? `Add to Cart — ${money(variant.price)}`
          : 'Sold Out';
      }

      // Update URL
      const url = new URL(window.location);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url);
    }

    // Listen to option changes
    $$('.option-btn__input').forEach(input => {
      input.addEventListener('change', () => {
        const group = input.closest('.product-option');
        const idx = parseInt(group.dataset.optionIndex);
        selectedOptions[idx] = input.value;
        updateUI(findVariant());
      });
    });

    // Gallery thumbs
    $$('.product-gallery__thumb').forEach(thumb => {
      thumb.addEventListener('click', () => {
        const mainImg = $('gallery-main-img');
        if (mainImg && thumb.dataset.src) {
          mainImg.src = thumb.dataset.src;
          $$('.product-gallery__thumb').forEach(t => t.classList.remove('active'));
          thumb.classList.add('active');
        }
      });
    });

    // ATC form submit
    productForm.addEventListener('submit', async e => {
      e.preventDefault();
      if (addToCartBtn.disabled) return;
      const variantId = parseInt(variantInput.value);
      const qty = parseInt($('qty-input')?.value || '1');
      addToCartBtn.textContent = 'Adding...';
      addToCartBtn.classList.add('btn--loading');
      try {
        await addToCart(variantId, qty);
        addToCartBtn.textContent = '✓ Added!';
        setTimeout(() => {
          addToCartBtn.textContent = `Add to Cart — ${money(findVariant().price)}`;
          addToCartBtn.classList.remove('btn--loading');
        }, 1200);
        openCart();
      } catch {
        showToast('Could not add to cart. Try again.');
        addToCartBtn.classList.remove('btn--loading');
        addToCartBtn.textContent = `Add to Cart — ${money(findVariant().price)}`;
      }
    });

    // Qty stepper
    $('qty-minus')?.addEventListener('click', () => {
      const inp = $('qty-input');
      if (inp && parseInt(inp.value) > 1) inp.value = parseInt(inp.value) - 1;
    });
    $('qty-plus')?.addEventListener('click', () => {
      const inp = $('qty-input');
      if (inp) inp.value = parseInt(inp.value) + 1;
    });

    // Accordion
    const descToggle = $('desc-toggle');
    const descBody = $('desc-body');
    if (descToggle && descBody) {
      descToggle.addEventListener('click', () => {
        const expanded = descToggle.getAttribute('aria-expanded') === 'true';
        descToggle.setAttribute('aria-expanded', !expanded);
        descBody.classList.toggle('hidden', expanded);
      });
    }

    // Copy link
    $('copy-link')?.addEventListener('click', () => {
      navigator.clipboard.writeText(window.location.href).then(() => showToast('Link copied!'));
    });
  }

  /* ---- SIZE GUIDE MODAL ---- */
  const sizeModal = $('size-modal');
  const sizeOverlay = $('size-overlay');
  const sizeClose = $('size-close');

  function openSizeGuide() {
    sizeModal?.classList.add('open');
    sizeOverlay?.classList.add('open');
    sizeModal?.setAttribute('aria-hidden', 'false');
  }
  function closeSizeGuide() {
    sizeModal?.classList.remove('open');
    sizeOverlay?.classList.remove('open');
    sizeModal?.setAttribute('aria-hidden', 'true');
  }

  $('open-size-guide')?.addEventListener('click', openSizeGuide);
  sizeClose?.addEventListener('click', closeSizeGuide);
  sizeOverlay?.addEventListener('click', closeSizeGuide);
  $('footer-size-guide')?.addEventListener('click', e => { e.preventDefault(); openSizeGuide(); });

  /* ---- QUICK ADD ---- */
  async function handleQuickAdd(btn) {
    const handle = btn.dataset.productHandle;
    if (!handle) return;

    try {
      const res = await fetch(`/products/${handle}.js`);
      const product = await res.json();

      if (product.variants.length === 1) {
        btn.textContent = 'Adding...';
        await addToCart(product.variants[0].id, 1);
        btn.textContent = '✓ Added!';
        openCart();
        setTimeout(() => btn.textContent = 'Quick Add', 1500);
      } else {
        showQuickAddModal(product, btn);
      }
    } catch {
      showToast('Could not add item. Try again.');
    }
  }

  function showQuickAddModal(product, triggerBtn) {
    let modal = $('quick-add-modal');
    if (!modal) {
      modal = document.createElement('div');
      modal.id = 'quick-add-modal';
      modal.className = 'quick-add-modal';
      document.body.appendChild(modal);
    }

    const sizeOption = product.options.find(o => o.name.toLowerCase() === 'size');
    const options = sizeOption ? sizeOption.values : product.options[0]?.values || [];

    modal.innerHTML = `
      <div class="quick-add-modal__header">
        <div>
          <div class="quick-add-modal__title">${product.title}</div>
          <div class="quick-add-modal__price">${money(product.price_min)}</div>
        </div>
        <button class="cart-drawer__close" id="quick-close">✕</button>
      </div>
      <div class="product-option__values">
        ${options.map(v => {
          const variant = product.variants.find(vr => vr.option1 === v || vr.option2 === v);
          const avail = variant ? variant.available : false;
          return `<label class="option-btn ${!avail ? 'option-btn--sold' : ''}">
            <input type="radio" name="qa-size" value="${v}" ${!avail ? 'disabled' : ''} class="option-btn__input">
            <span class="option-btn__label">${v}</span>
          </label>`;
        }).join('')}
      </div>
      <button class="btn btn--gold btn--full btn--xl" id="qa-atc" style="margin-top:20px;" disabled>Select a Size</button>
    `;

    modal.classList.add('open');

    $('quick-close')?.addEventListener('click', () => modal.classList.remove('open'));

    modal.querySelectorAll('input[name="qa-size"]').forEach(inp => {
      inp.addEventListener('change', () => {
        const atcBtn = $('qa-atc');
        if (atcBtn) {
          atcBtn.disabled = false;
          atcBtn.textContent = `Add to Cart — ${money(product.price_min)}`;
          atcBtn.dataset.value = inp.value;
          atcBtn.dataset.handle = product.handle;
        }
      });
    });

    $('qa-atc')?.addEventListener('click', async function () {
      const val = this.dataset.value;
      const variant = product.variants.find(v => v.option1 === val || v.option2 === val);
      if (!variant) return;
      this.textContent = 'Adding...';
      await addToCart(variant.id, 1);
      modal.classList.remove('open');
      openCart();
    });
  }

  document.addEventListener('click', e => {
    const btn = e.target.closest('.prod-card__quick-add');
    if (btn) { e.preventDefault(); handleQuickAdd(btn); }
  });

  /* ---- CART PAGE QTY ---- */
  $$('.cart-qty-btn').forEach(btn => {
    btn.addEventListener('click', async () => {
      const line = parseInt(btn.dataset.line);
      const inp = document.querySelector(`[name="updates[]"]:nth-of-type(${line})`);
      let qty = parseInt(inp?.value || 1);
      qty = btn.dataset.action === 'increase' ? qty + 1 : Math.max(0, qty - 1);
      if (inp) inp.value = qty;
      const cart = await updateCartLine(line, qty);
      if (qty === 0) location.reload();
      const subtotalEl = $('cart-subtotal');
      if (subtotalEl) subtotalEl.textContent = money(cart.total_price);
    });
  });

  /* ---- COLLECTION SORT ---- */
  const sortSelect = document.getElementById('sort-by');
  sortSelect?.addEventListener('change', function () {
    const url = new URL(window.location);
    url.searchParams.set('sort_by', this.value);
    window.location = url.toString();
  });

  /* ---- SCROLL REVEAL ---- */
  const revealObs = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.classList.add('visible');
        revealObs.unobserve(e.target);
      }
    });
  }, { threshold: 0.08 });

  $$('.reveal').forEach((el, i) => {
    el.style.transitionDelay = (i % 4) * 0.08 + 's';
    revealObs.observe(el);
  });

  /* ---- PRODUCT RECOMMENDATIONS ---- */
  const recsEl = document.querySelector('.product-recommendations');
  if (recsEl) {
    const pid = document.querySelector('.product-page')?.dataset.productId;
    if (pid) {
      fetch(`/recommendations/products.json?product_id=${pid}&limit=4`)
        .then(r => r.json())
        .then(data => {
          if (data.products?.length) {
            // Recommendations are already rendered server-side via Liquid
          }
        }).catch(() => {});
    }
  }

})();
